import React from 'react'
import { Box, Skeleton } from '@mui/material'

const HeaderBlock = () => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Skeleton variant="circular" width={32} height={32} />
                <Skeleton variant="text" width={120} height={24} />
            </Box>
        </Box>
    )
}

export default HeaderBlock
